import { Button, Form, ResultsCard, ResultsToolbar } from 'shared/components/ui';
import React, { useState } from 'react';
import { VpnKey } from '@mui/icons-material';

import { Save, OpenInNew } from '@mui/icons-material';
import Header from '../../../shared/components/layout/Header';
import Footer from '../../../shared/components/layout/Footer';
import { Alert } from '../../../shared/components';
import { Toast } from '../../../shared/components/Toast';
import { tokensAPI } from '../../../core/api/api';
import '../../../features/turnos/components/GrillaTurnos.css';

const GrillaTokens = () => {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const handleGuardar = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await tokensAPI.enviarToken(token.trim());
      const msg = res.data || 'Token guardado con éxito.';
      setToast({ message: msg, type: msg.toLowerCase().includes('incorrecto') ? 'error' : 'success' });
    } catch {
      setError('Error al guardar el token. Por favor intente más tarde.');
    } finally {
      setLoading(false);
    }
  };

  const handleGenerarTokenDropBox = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await tokensAPI.enviarToken('');
      const texto = res.data;
      const idx = typeof texto === 'string' && texto.indexOf('https://www.dropbox.com/oauth2/authorize?');
      if (idx !== -1) window.open(texto.substring(idx), '_blank');
    } catch {
      setError('Error al generar el Token de DropBox. Por favor intente más tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grilla-turnos">
      <Header />
      <div className="main-content">
        <div className="page-header">
          <h2 className="page-title-grilla">
            <VpnKey sx={{ fontSize: 32, mr: 1, verticalAlign: 'middle', color: '#6d1212' }} />
            Tokens
          </h2>
          <span className="page-subtitle">Configuración de tokens de integración</span>
        </div>

        <Alert message={error} onClose={() => setError('')} />

        <ResultsCard className="results-card">
          <ResultsToolbar className="results-header">
            <h3 className="results-title">Token DropBox</h3>
          </ResultsToolbar>
          <Form onSubmit={handleGuardar} style={{ padding: '1rem' }}>
            <Form.Group className="mb-3">
              <Form.Label>* Token DropBox</Form.Label>
              <Form.Control
                type="text"
                maxLength={100}
                placeholder="Token de DropBox..."
                value={token}
                onChange={(e) => setToken(e.target.value)}
                required
              />
            </Form.Group>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              <Button type="submit" variant="success" size="sm" disabled={loading || !token.trim()}>
                <Save sx={{ fontSize: 16, mr: 0.5 }} /> Guardar
              </Button>
              <Button variant="secondary" size="sm" onClick={handleGenerarTokenDropBox} disabled={loading}>
                <OpenInNew sx={{ fontSize: 16, mr: 0.5 }} /> Generar Token DropBox
              </Button>
            </div>
            <p className="mt-3" style={{ fontSize: '0.8rem', color: '#6b7280' }}>
              Los campos marcados con asterisco (*) son obligatorios.
            </p>
          </Form>
        </ResultsCard>
      </div>
      <Footer />
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};

export default GrillaTokens;
